import type { MiddlewareData, Placement, useFloating } from '@floating-ui/react';
import { createContext, type Ref, useContext } from 'react';

import type { Color } from '../../../types/colors';

export type SgTooltipMode = 'hover' | 'click' | 'focus' | 'persistent';

export type SgTooltipContextType = {
  placement: Placement;
  color: Color;
  backgroundColor: Color;
  refs: ReturnType<typeof useFloating>['refs'];
  floatingStyles: ReturnType<typeof useFloating>['floatingStyles'];
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  mode: SgTooltipMode;
  referenceElement: HTMLElement | null;
  setReferenceElement: (el: HTMLElement | null) => void;
  floatingContext: ReturnType<typeof useFloating>['context'];
  arrow: MiddlewareData['arrow'];
  hide: MiddlewareData['hide'];
  arrowRef?: Ref<SVGSVGElement>;
};

export const SgTooltipContext = createContext<SgTooltipContextType | undefined>(undefined);

export const useSgTooltipContext = () => {
  const context = useContext(SgTooltipContext);

  if (!context) {
    throw new Error('useSgTooltipContext doit être utilisé dans un SgTooltipProvider');
  }

  return context;
};
